import {AfterViewInit, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {UserService} from "./shared/user.service";
import {InitjsService} from '../shared/initjs.service';
import {AlertService} from '../shared/alert.service';
import {QueryParam} from '../shared/query-param';
import {HttpService} from '../shared/http.service';
import {UserResponse} from '@builtbybros/al-model';
import {isPlatformBrowser} from "@angular/common";
import * as moment from 'moment';

import 'moment/locale/es';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  entity = 'user';
  title = 'Usuarios';
  users = {};
  usersReady = false;
  loading = false;
  actions = true;
  prevPath = '/user/';
  columns = [
    ['name', 'Nombre'],
    ['lastName', 'Apellido'],
    ['email', 'Email'],
    ['userRoleId', 'Rol']
  ];
  hasDataTables = false;
  roles = {
    '1' : 'Administrador',
    '2' : 'Cliente',
    '3' : 'Consignatario',
    '4' : 'Institución educativa'
  };
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];
  msg = {
    'deleteSuccess': 'Usuario borrado con éxito',
    'deleteError': 'Ocurrió un error al borrar usuario',
    'downloadError': 'Ha ocurrido un error. No fue posible descargar el archivo.'
  };

  states = [
    [1, 'Activo'],
    [2, 'Inactivo']
  ];
  typeUsers = [
    [1, 'Admin'],
    [2, 'Cliente'],
    [3, 'Consignatario'],
    [4, 'Escuela']
  ];

  downloading = false;

  defaultState = 0;
  defaultTypeUser = 1;
  pagination = 100;
  query = '';
  offset = 0;

  constructor(private userService: UserService,
              private httpService: HttpService,
              private initJsService: InitjsService,
              private alertService: AlertService,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    this.getAllUsers();
    this.initJsService.initJs();
  }

  getAllUsers() {
    const params = new Array<QueryParam>();
    params[0] = new QueryParam('pagination', this.pagination.toString());
    params[1] = new QueryParam('offset', this.offset.toString());
    params.push(new QueryParam('active', this.defaultState.toString()));
    params.push(new QueryParam('role', this.defaultTypeUser.toString()));
    params.push(new QueryParam('query', this.query));

    this.httpService.getWithParams('/User/All', params, UserResponse.All)
      .subscribe(
        userResponse => {
          this.users = userResponse;
          for (const u of this.users['objects']) {
            u['userRoleId'] = this.roles[u['userRoleId']];
          }
          this.usersReady = true;
          this.loading = false;
        },
        error => {
          console.log('error', error);
        }
      );
  }

  filterStates(value) {
    this.loading = true;
    this.defaultState = +value;
    this.getAllUsers();
  }

  filterTypeUsers(value) {
    this.loading = true;
    this.defaultTypeUser = +value;
    this.getAllUsers();
  }

  setQuery(value) {
    console.log('setQuery value', value);
    // value = '';
    this.loading = true;
    this.query = value;
    this.getAllUsers();
  }

  setLimit(value) {
    this.pagination = +value;
    this.getAllUsers();
  }

  setOffset(value) {
    this.offset = +value;
    this.getAllUsers();
  }

  delete(id) {
    this.httpService.delete('/User/', id)
      .subscribe(
        updateResponse => {
          this.getAllUsers();
          this.alertService.success(this.msg['deleteSuccess']);
        },
        error => {
          this.alertService.error(this.msg['deleteError']);
        },
        () => console.log('Request Complete')
      );
  }

  downloadAllUsers() {
    if (isPlatformBrowser(this.platformId)) {
      this.downloading = true;
      const date = moment().format('YYYY-MM-DD_HH-mm-ss');
      this.httpService.downloadFile(`/User/All/Download`, `Usuarios_${date}.xlsx`)
        .subscribe(res => {
            this.downloading = false;
          },
          error => {
            this.alertService.error(this.msg['downloadError']);
            console.log('ERROR', error);
            this.downloading = false;
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/user/user.component.ts